/** Normalize assistant text so ReactMarkdown renders lists and steps correctly. */
export function normalizeAgentChatMarkdown(raw: string): string {
  if (!raw) return '';
  let text = raw.replace(/\r\n/g, '\n');

  // Unicode bullets from backend replies are not markdown list markers — convert them.
  text = text.replace(/^\s*•\s+/gm, '- ');

  text = text
    .split('\n')
    .map((line) =>
      line.replace(
        /^\s{4,}(?=(\d+\.\s|[-*]\s|#{1,6}\s|\*\*|>|\|))/,
        '',
      ),
    )
    .join('\n');

  text = text.replace(/(^|\n)\s*["'](\*\*[^"\n]+\*\*)["']\s*(?=\n|$)/g, '$1$2');
  text = text.replace(/Step\s+(\d+)\s*:\s*/gi, '\n$1. ');
  text = text.replace(/([^\n])\n(\d+\.\s)/g, '$1\n\n$2');
  text = text.replace(/\s+([*-]\s+)/g, '\n$1');
  text = text.replace(/\n{2,}(\d+\.\s)/g, '\n$1');
  text = text.replace(/(\d+\.\s[^\n]+)\s+(\d+\.\s)/g, '$1\n$2');
  text = text.replace(/\n{3,}/g, '\n\n').trim();
  return text;
}
